import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  // 薪资首页
  {
    path: '/habiSalary',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SalaryIndex" */ '~/pages/Union/SalaryWallet/pages/SalaryIndex'
        )
    ),
  },
  // 薪资流转
  {
    path: '/habiSalary/TradeSalary/:page',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-TradeSalary" */ '~/pages/Union/SalaryWallet/pages/TradeSalary'
        )
    ),
  },
  // 工会长和主播共用的各种支付方式的绑定页面
  {
    path: '/habiSalary/BindTrustee',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-BindTrustee" */ '~/pages/Union/SalaryWallet/pages/BindTrustee'
        )
    ),
  },
  // 薪资记录
  {
    path: '/habiSalary/SalaryRecord',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-SalaryRecord" */ '~/pages/Union/SalaryWallet/pages/SalaryRecord'
        )
    ),
  },
  // 代收薪资记录（代收主播）
  {
    path: '/habiSalary/EraAnchorRecord',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-EraAnchorRecord" */ '~/pages/Union/SalaryWallet/pages/EraAnchorRecord'
        )
    ),
  },
  // 代收薪资记录（代收他人）
  {
    path: '/habiSalary/EraOtherRecord',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-EraOtherRecord" */ '~/pages/Union/SalaryWallet/pages/EraOtherRecord'
        )
    ),
  },
] as RouteConfig[]
